module.exports = __webpack_public_path__ + "static/media/9.d25e63c9.webp";